import { useCallback } from "react";
import { useCart } from "./useCart";
import { useShopConfig } from "./useShopConfig";
import { ShipmentMethod } from "@egocentric-systems/ts-apis/shop_config/types/v1/shipment_pb";
import dayjs from "dayjs";
import { CartItem } from "~/lib/definitions";
import { SeatUpgrade } from "@egocentric-systems/ts-apis/booking/types/v1/order_pb";

export function useIsShipingMethodActiveForCart() {
  const items = useCart(({ items }) => items);
  const seatUpgrades = useCart(({ seatUpgrades }) => seatUpgrades);

  const {
    shopConfig: { shipmentConfiguration },
  } = useShopConfig();

  const hasFanticketUgradeInCart = seatUpgrades.some(
    (upgrade) => upgrade.seatUpgrade === SeatUpgrade.FANTICKET,
  );

  return useCallback(
    (shipmentMethod: ShipmentMethod, itemToCheck?: CartItem) => {
      if (
        hasFanticketUgradeInCart &&
        shipmentMethod !== ShipmentMethod.POSTAL
      ) {
        return false;
      }

      const period = shipmentConfiguration?.activationPeriods.find(
        (period) => period.method === shipmentMethod,
      );

      const itemsToCheck = itemToCheck ? [...items, itemToCheck] : items;

      return !itemsToCheck.some((item) => {
        const startDate = dayjs.tz(
          item.eventOrBundle.value.start?.time,
          item.eventOrBundle.value.start?.timezone,
        );

        const isNotYetActivated =
          !!period?.activateDaysBeforeEvent &&
          dayjs()
            .add(period.activateDaysBeforeEvent, "days")
            .isBefore(startDate);

        const isDeactivated =
          !!period?.deactivateDaysBeforeEvent &&
          dayjs()
            .add(period?.deactivateDaysBeforeEvent, "days")
            .isAfter(startDate);

        return isNotYetActivated || isDeactivated;
      });
    },
    [shipmentConfiguration, items, hasFanticketUgradeInCart],
  );
}
